import { Page } from '@bloomreach/spa-sdk';
import { Link, LinkCollection } from '../types/doc-types.type';

export interface FileInfo {
  fileName: string;
  fileExtension: string;
  file: string;
}

/**
 * Parse widen document json and read url
 * @param widenDocument json string
 */
export function getWidenDocumentUrl(widenDocument: any): string {
  let url;
  if (widenDocument) {
    const widenJson = JSON.parse(widenDocument);
    url = widenJson.url;
  }
  return url;
}

/**
 * Process the linkcompound for template usage
 * @param linkCompound link object
 * @param page brxm sdk page object
 * @param cmsURL optional url string
 */
export function processLink(
  linkCompound: Link,
  page: Page,
  cmsURL: string
): Link {
  if (linkCompound) {
    for (let link of linkCompound.linkCollection) {
      link = processLinkCollection(link, page, cmsURL);
    }
    return linkCompound.linkCollection[0] || linkCompound;
  }
}

/**
 * Process the link collection object
 * @param link link collection object
 * @param page brxm sdk page object
 * @param cmsURL optional url string
 */
export function processLinkCollection(
  link: LinkCollection,
  page: Page,
  cmsURL?: string
): LinkCollection {
  if (link) {
    if (link.document) {
      link.url = page.getContent(link.document).getUrl();
    } else if (link.widenAssetCompound) {
      link.url = getWidenDocumentUrl(link.widenAssetCompound?.widenDocument);
    } else if (link.url) {
      const regex = new RegExp('(^http:|^https:|^mailto:)');
      if (regex.test(link.url)) {
        link.url = link.url;
      } else {
        if (cmsURL) {
          if (link.url.startsWith('/')) {
            link.url = `${cmsURL}${link.url}`;
          } else {
            link.url = `${cmsURL}/${link.url}`;
          }
        }
      }
    }
  }
  return link;
}

export function extractFileInfoFromLink(link: string): FileInfo {
  // remove params ? and # if present in url
  // then splits this string by /
  const linkSplit = link.split(/[?#]/)[0].split('/');

  const file = linkSplit[linkSplit.length - 1].split('.');
  return {
    fileName:
      file.length > 2 ? [...file].slice(0, file.length - 1).join('.') : file[0],
    fileExtension: file.length > 1 ? file[1].toLowerCase() : '',
    file: linkSplit[linkSplit.length - 1],
  };
}

/**
 *
 * @param themePath helper function extracting theme name from path
 */
export function getThemeNameFromPath(themePath: string): string {
  return themePath?.replace(
    /\/assets\/css\/([a-z0-9]+).theme.css\?v=([0-9a-z\.]+)/,
    '$1'
  );
}

/**
 * Returns clicked Anchor element
 * @param event - click event
 */
export function checkLink(event: MouseEvent): EventTarget {
  if (
    event.target instanceof HTMLAnchorElement ||
    event.target instanceof HTMLButtonElement
  ) {
    return event.target;
  }
  // Try to find anchor element in event patch
  const anchorEl = event
    .composedPath()
    .find((el) => el instanceof HTMLAnchorElement);
  if (anchorEl) {
    return anchorEl;
  }
  // Try to find button element in event patch
  const buttonEl = event
    .composedPath()
    .find((el) => el instanceof HTMLButtonElement);
  if (buttonEl) {
    return buttonEl;
  }
}
